export function getLinkDim(link) {
    return link.experimentType === '1d' ? 1 : 2;
}
//# sourceMappingURL=getLinkDim.js.map